export default __webpack_public_path__ + "static/meta-image-424428d15aeebb665121fb0c6034e552.png";